import type { Legacy_ModalProps } from '@flex-design-system/fx';
import {
  Avatar,
  Button,
  Flex,
  Legacy_Modal,
  Typography,
} from '@flex-design-system/fx';
import { styled } from '@flex-design-system/stitches-react';
import { Translation } from '@flex-packages/i18n';
import { trans } from '@flex-packages/i18n-base';
import { Link } from '@flex-packages/router';
import { EmojiView } from '@flex-services/emoji';
import { useFormContext, useWatch } from 'react-hook-form';

import { getMobileStyle } from '../../../utils';
import type { JobDescriptionFormState } from '../models';

interface Props extends Legacy_ModalProps {
  mainPageLink: string;
}

export function SubmittedModal({ mainPageLink, ...props }: Props) {
  const { control } = useFormContext<JobDescriptionFormState>();
  const name = useWatch({ control, name: 'name' });

  return (
    <Legacy_Modal {...props}>
      <Legacy_Modal.Content>
        <Legacy_Modal.ScrollArea
          css={{
            paddingTop: 66,
            paddingBottom: 40,

            ...getMobileStyle({
              minWidth: 'calc(100vw - 40px)',
            }),
          }}
        >
          <Legacy_Modal.Body>
            <Flex direction="column" align="center" css={{ gap: 24 }}>
              <Avatar color="presetYellow" colorScheme="weak" size={64}>
                <EmojiView code="1f4ab" />
              </Avatar>
              <Flex direction="column" align="center" css={{ gap: 14 }}>
                <Typography
                  size={28}
                  color="grayDark"
                  lineHeight={1.4}
                  weight={700}
                  css={{ textAlign: 'center', wordBreak: 'keep-all' }}
                  asChild
                >
                  <Translation
                    tKey={trans(
                      'recruiting.site_builder.job_description.apply.success.title'
                    )}
                    tOptions={{ values: { name } }}
                  />
                </Typography>
                <Typography
                  size={15}
                  color="gray"
                  lineHeight={1}
                  weight={400}
                  css={{ textAlign: 'center', wordBreak: 'keep-all' }}
                  asChild
                >
                  <Translation
                    tKey={trans(
                      'recruiting.site_builder.job_description.apply.success.description'
                    )}
                  />
                </Typography>
              </Flex>
            </Flex>
          </Legacy_Modal.Body>
        </Legacy_Modal.ScrollArea>
        <Legacy_Modal.Footer>
          <FullWidthLink>
            <Link href={mainPageLink} passHref>
              <Button fullWidth size="large" color="grayDarker">
                <Translation
                  tKey={trans(
                    'recruiting.site_builder.job_description.apply.success.action'
                  )}
                />
              </Button>
            </Link>
          </FullWidthLink>
        </Legacy_Modal.Footer>
      </Legacy_Modal.Content>
    </Legacy_Modal>
  );
}

const FullWidthLink = styled('div', {
  width: '100%',
  '& a': { display: 'block', width: '100%' },
});
